import {all} from "redux-saga/effects";

import common from "./common/saga";
import journal from "./pages/journal/saga";
import profile from "./pages/profile/saga";
import plans from "./pages/plans/saga";
import schedule from "./pages/schedule/saga";
import printJournal from "./pages/printJournal/saga";
import rup from "./pages/rup/saga";
import library from "./pages/library/saga";
import admission from "./pages/admission/saga";
import exam from "./pages/exam/saga";
import psychologist from "./pages/psychologist/saga";

export default function* rootSaga(){
  yield all([
    common(),
    journal(),
    profile(),
    plans(),
    schedule(),
    printJournal(),
    rup(),
    library(),
    exam(),
    admission(),
    exam(),
    psychologist()
  ])
}